import { createItemGroups, createItemTabs } from '@/lib/Orders/orderItemGroups';

export function createOrderDetailsStore() {
    return {
        namespaced: true,

        state: {
            /**
             * @type {Order|null}
             */
            currentOrder: null,

            /**
             * The itemType of the currently selected tab (e.g. Ticket, Product, Membership Plan, etc.).
             * This is different to currentGroup because the Tickets tab can contain multiple groups for multiple
             * events or a mixture of events and tickets.
             *
             * @type {string|null}
             */
            currentTab: null,

            /**
             * @type {OrderWaiverStatus|null}
             */
            currentOrderWaiverStatus: null,

            /**
             * @type {boolean}
             */
            currentOrderIsCrossBranch: false,

            /**
             * @type {boolean}
             */
            currentOrderIsFromBarcodeScan: false,

            /**
             * If an error was encountered loading the tax summary for the order.
             *
             * @type {Error|null}
             */
            taxLoadError: null,
        },

        mutations: {
            reset(state) {
                state.currentOrder = null;
                state.currentTab = null;
                state.currentOrderWaiverStatus = null;
                state.currentOrderIsCrossBranch = false;
                state.currentOrderIsFromBarcodeScan = false;
                state.taxLoadError = null;
            },

            setCurrentOrder(state, value) {
                // While using Angular controllers + Vue cloneDeep forces vue to notice deeply nested changes.
                // state.currentOrder = cloneDeep(value);
                state.currentOrder = value;
                state.currentOrderWaiverStatus = null;
            },

            setCurrentTab(state, value) {
                state.currentTab = value;
            },

            setCurrentOrderWaiverStatus(state, value) {
                state.currentOrderWaiverStatus = value;
            },

            setCurrentOrderIsCrossBranch(state, value) {
                state.currentOrderIsCrossBranch = value;
            },

            setCurrentOrderIsFromBarcodeScan(state, value) {
                state.currentOrderIsFromBarcodeScan = value;
            },

            setTaxLoadError(state, value) {
                state.taxLoadError = value;
            },
        },

        getters: {
            /**
             * @param {{}} state
             *
             * @return {boolean}
             */
            currentOrderHasIncompleteWaivers(state) {
                return state.currentOrderWaiverStatus
                    ? state.currentOrderWaiverStatus.hasIncompleteWaivers()
                    : false;
            },

            /**
             * Build the itemGroups here so we can then read them in Angular and Vue rather than having to build
             * them twice and avoid possible issues by having a single source of truth.
             *
             * As Vuex getters are cached this is only rebuilt when state.currentOrder changes.
             *
             * @param {{}} state
             *
             * @return {OrderItemGroup[]}
             */
            itemGroups(state) {
                if (!state.currentOrder?.items) {
                    return [];
                }
                return createItemGroups(state.currentOrder.items);
            },

            /**
             * @param {{}} state
             * @param {{}} getters
             *
             * @return {OrderItemTab[]}
             */
            itemTabs(state, getters) {
                return createItemTabs(getters.itemGroups);
            },
        },
    };
}
